<template>
  <AddTeacher />
</template>
<script>
import appConfig from '@/app.config'
import AddTeacher from '../../../components/skillup/teachers/AddTeacher.vue'
export default {
  page: {
    title: 'اضافه کردن استاد',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'skillUp-add-teachers',
  components: {
    AddTeacher,
  },
}
</script>
